/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useCallback } from 'react';

import { Radio, RadioGroup } from '@coursera/cds-core';

import type { FlagCategory } from 'bundles/authoring-course-content-feedback/types/courseContentFeedback';

import _t from 'i18n!nls/content-feedback';

const styles = {
  radioGroup: css`
    margin-bottom: var(--cds-spacing-100);

    label {
      margin-bottom: 0 !important;
    }
  `,
};

type Props = {
  onCategoryChange: (id: string) => void;
  category: FlagCategory;
  categories: FlagCategory[];
};

const FlagCategories: React.FC<Props> = ({ category, categories, onCategoryChange }) => {
  const onChange = useCallback<(...args: $TSFixMe[]) => $TSFixMe>(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      if (category.id !== value) {
        onCategoryChange(value);
      }
    },
    [category, onCategoryChange]
  );

  return (
    <div data-testid="flag-categories">
      <RadioGroup
        onChange={onChange}
        value={category.id}
        label={_t("Select an issue you'd like to report")}
        css={styles.radioGroup}
      >
        {categories.map((value) => (
          <Radio key={value.id} value={value.id} label={value.label} />
        ))}
      </RadioGroup>
    </div>
  );
};

export default FlagCategories;
